<template>
  <div class="remark-item-container">
    <div class="remark-item-content-right" v-if="!item.answer.length">
      <p>No Answers Added.</p>
    </div>
    <div v-for="(answer, i) in item.answer" class="res-list-item-content">
      <div class="remark-item-content-right">
        <el-button
          style="position: absolute; top: 0.75rem; right: 0.5rem; z-index: 10"
          v-if="['video', 'audio'].includes(Fn.fileType(answer)) && $route.name === 'd'"
          icon="el-icon-monitor"
          :disabled="isStudentPaced"
          circle
          @click="$store.dispatch('fullPlay', {fullPlayUrl: Fn.hashToUrl(answer), fullPlayOn: 'projector'})" />
        <!--
    <el-tooltip 
      style="position: absolute; top: 0.5rem; right: 0.5rem; z-index: 10"
      v-if="['file'].includes(Fn.fileType(answer)) && $route.name === 'd'" 
      class="item" 
      effect="dark" 
      content="Draw it" 
      placement="top-start">
      <i @click="setSyncUI({ drawUrl: Fn.hashToUrl(getPage.pic || getPage.url), drawShow: false, drawText: item._id})" class="answer-footer-button draw"></i>
    </el-tooltip>
      -->
        <el-button
          style="position: absolute; top: 0.5rem; right: 0.5rem; z-index: 10"
          v-if="['file'].includes(Fn.fileType(answer)) && $route.name === 'd'"
          :disabled="isStudentPaced"
          circle
          @click="setSyncUI({drawUrl: Fn.hashToUrl(getPage.pic || getPage.url), drawShow: false, drawText: item._id})">
          <i class="draw-it"></i>
        </el-button>
        <videoPlayer v-if="Fn.fileType(item.answer[i]) === 'video'" controlslist="nodownload" :src="item.answer[i]" width="280" height="150" :controls="true" />
        <div v-else-if="Fn.fileType(answer) === 'audio'" style="width: 100%; padding-right: 50px">
          <audioPlayer :url="answer" />
        </div>
        <div class="remark-img" v-else-if="Fn.fileType(answer) === 'task'" @click="$store.dispatch('upFullDoc', {url: answer})">
          <base64image v-if="answer && answer.includes(':')" :url="answer.split(':')[0]" />
        </div>
        <div class="remark-img" v-else-if="Fn.fileType(answer) === 'image'">
          <base64image :url="answer" :showPreview="true" :noSync="noSync" />
        </div>
        <div class="remark-file-right" v-else-if="Fn.fileType(answer) === 'pdf'" @click="$store.dispatch('upFullDoc', {url: answer})">
          <div class="file-icon" :class="Fn.fileIcon(answer)"></div>
          <div class="flex1">
            <p class="file-name-right">{{ fileName(i) }}</p>
          </div>
        </div>
        <div class="remark-file-right" v-else>
          <p class="file-name-right" :class="{'deleted-response': !answer}" style="padding-right: 2.5rem">{{ answer || 'Deleted Response' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import audioPlayer from '@/components/common/audioPlayer.vue'
import videoPlayer from '@/components/common/videoPlayer.vue'
import base64image from '@/components/base64image.vue'

export default {
  components: {audioPlayer, videoPlayer, base64image},
  props: {
    item: {type: Object, default: () => {}},
  },
  methods: {
    ...mapActions(['setSyncUI']),
    fileName(i) {
      if (!this.item.answer[i]?.split) return ''
      console.log(`this.item.answer[${i}]`, this.item.answer[i])
      return this.item.answer[i].split(':').pop()
    },
  },
  computed: {
    ...mapGetters(['isStudentPaced', 'getPage']),
  },
}
</script>
<style scoped>
.remark-item-container {
  max-height: 50vh;
  overflow-y: auto;
}

.draw-it {
  background-image: url(../../../assets/picture/draw.png);
  cursor: pointer;
  width: 15px;
  height: 15px;
  background-position: 0 0;
  background-size: 15px 15px;
  background-repeat: no-repeat;
  display: block;
}
.el-icon-edit {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px;
}
@import url(./dash-right.css);
</style>
